import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User activated Intercom',
  name: 'Activated Intercom',
  params: [
    {
      description: 'The location where the user activated Intercom',
      name: 'location',
      required: true,
      type: 'enum',
      values: [
        'cancel-workspace-subscription',
        'enterprise-contact-sales',
        'main-nav',
        'settings',
        'workspace-popover',
      ],
    },
  ],
};

export default META;
